import React from "react";
import "./index.css";

const DashboardHeader = ({ text }) => {
  return <div className="dashboard-header-title">{text}</div>;
};

export default DashboardHeader;
